module.exports = __webpack_public_path__ + "img/ar.91013f67.svg";